import SearchParticipantContext from "../../container/searchParticipant/context/searchParticipantContext";
import SearchParticipantContainer from "../../container/searchParticipant/searchParticipantContainer";

const SearchParticipant = (): React.JSX.Element => (
  <SearchParticipantContext>
    <SearchParticipantContainer />
  </SearchParticipantContext>
);

export default SearchParticipant;
